/**
 * B2 — Piezas comunes de los libros contables: filtros de emisor y año, y formato de tipos
 * de IVA. Son informes orientativos para la gestoría; no sustituyen a los modelos oficiales.
 */
import { useEffect, useState } from 'react'
import { api } from '../../lib/api'
import type { IssuerDto } from '@toga/shared'

export const selectCls =
  'bg-transparent border border-base rounded-lg px-3 py-1.5 text-sm t-primary focus:outline-none focus:border-toga-500/50'

export const th = 'px-3 py-2 text-left text-[11px] uppercase tracking-wider t-faint font-medium'
export const thR = `${th} text-right`
export const td = 'px-3 py-2'
export const tdR = `${td} text-right font-mono whitespace-nowrap`

/** «0.2100» → «21 %» */
export function rateLabel(rate: string): string {
  const pct = Number(rate) * 100
  return `${Number.isInteger(pct) ? pct : pct.toFixed(1).replace('.', ',')} %`
}

const ISSUERS_CHANGED = 'toga:issuers-changed'

/** Avisa a quien muestre emisores (menú lateral, pantallas de contabilidad) de que han cambiado. */
export function notifyIssuersChanged(): void {
  window.dispatchEvent(new Event(ISSUERS_CHANGED))
}

/** Emisores y si ya han llegado (para no mostrar un «no hay» mientras se cargan). Se refresca con `notifyIssuersChanged`. */
export function useIssuersState(): { issuers: IssuerDto[]; loaded: boolean } {
  const [state, setState] = useState<{ issuers: IssuerDto[]; loaded: boolean }>({
    issuers: [],
    loaded: false,
  })
  const [tick, setTick] = useState(0)
  useEffect(() => {
    const onChange = () => setTick((t) => t + 1)
    window.addEventListener(ISSUERS_CHANGED, onChange)
    return () => window.removeEventListener(ISSUERS_CHANGED, onChange)
  }, [])
  useEffect(() => {
    let alive = true
    api
      .get<{ items: IssuerDto[] }>('/issuers')
      .then((r) => alive && setState({ issuers: r.items, loaded: true }))
      .catch(() => alive && setState({ issuers: [], loaded: true }))
    return () => {
      alive = false
    }
  }, [tick])
  return state
}

export function useIssuers(): IssuerDto[] {
  return useIssuersState().issuers
}

export function yearOptions(): number[] {
  const y = new Date().getFullYear()
  return [y, y - 1, y - 2, y - 3, y - 4]
}

export function Note({ children }: { children: React.ReactNode }) {
  return <p className="px-5 py-3 text-xs t-faint border-t border-base">{children}</p>
}
